<template>
  <div class="registros-container">
    <h2 class="page-title">Meus Registros de Ponto</h2>

    <div class="filtro-container">
      <input type="date" v-model="dataSelecionada" class="input-date" />
      <button @click="buscarRegistros" class="btn-principal" :disabled="!dataSelecionada || loading">
        <i class="fas fa-search"></i> Buscar
      </button>
    </div>

    <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Carregando registros...</p>
    </div>

    <div v-else-if="registros.length === 0" class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-clock"></i>
      </div>
      <h2>Nenhum registro encontrado</h2>
      <p>Não há registros para a data selecionada.</p>
    </div>

    <div v-else class="table-container">
      <table class="registros-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Data</th>
            <th>Tipo</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Observação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="registro in registros" :key="registro.id">
            <td>{{ registro.id }}</td>
            <td>{{ formatDate(registro.timestamp) }}</td>
            <td class="capitalize">{{ registro.tipo }}</td>
            <td>{{ registro.latitude.toFixed(5) }}</td>
            <td>{{ registro.longitude.toFixed(5) }}</td>
            <td>{{ registro.observacao || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { pontoService } from '@/services/pontoService';

export default {
  name: 'RegistrosList',
  data() {
    return {
      loading: false,
      registros: [],
      dataSelecionada: '' // YYYY-MM-DD
    };
  },
  methods: {
    async buscarRegistros() {
      if (!this.dataSelecionada) return;
      this.loading = true;
      try {
        const response = await pontoService.getRegistrosPorData(this.dataSelecionada);
        this.registros = response.data.sort((a, b) => a.id - b.id);
      } catch (error) {
        console.error('Erro ao buscar registros:', error);
        alert(error.response?.data?.detail || 'Erro ao buscar registros');
      } finally {
        this.loading = false;
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return 'N/A';
      const date = new Date(timestamp);
      return date.toLocaleString('pt-BR');
    }
  }
};
</script>

<style scoped>
.registros-container { padding: 2rem; }
.page-title { text-align: center; color: #1e293b; margin-bottom: 1.5rem; }

.filtro-container { display: flex; justify-content: center; gap: 0.5rem; margin-bottom: 1rem; }
.input-date { padding: 0.5rem 1rem; border-radius: 6px; border: 1px solid #cbd5e1; }

.btn-principal { background-color: #3b82f6; color: white; border: none; border-radius: 8px; padding: 0.75rem 1rem; cursor: pointer; transition: 0.2s; }
.btn-principal:hover { background-color: #2563eb; }

.loading-container { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 2rem; }
.loading-spinner { width: 40px; height: 40px; border: 4px solid #e2e8f0; border-top: 4px solid #3b82f6; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 1rem; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

.empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 2rem; text-align: center; }
.empty-icon { font-size: 3rem; color: #cbd5e1; margin-bottom: 1rem; }
.empty-state h2 { margin: 0 0 0.5rem 0; color: #1e293b; }
.empty-state p { margin: 0; color: #64748b; }

.table-container { overflow-x: auto; margin-top: 1rem; }
.registros-table { width: 100%; border-collapse: collapse; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
.registros-table th, .registros-table td { padding: 0.75rem 1rem; text-align: left; border-bottom: 1px solid #e2e8f0; }
.registros-table th { background-color: #f3f4f6; color: #1e293b; font-weight: 600; }
.registros-table tr:last-child td { border-bottom: none; }
.capitalize { text-transform: capitalize; }
</style>
